<template>
    <div style="width: 70%;display: flex">
        <div style="flex-grow:2">
            <div v-for="(item,i) in items" :key="i+'aa'">
                <div style="width: 50%;display: inline-block;font-weight: bold"> {{ item.name }}
                    <span style="float:right;margin-right: 20px">: </span>
                </div>

                <div style="width: 40%;display: inline-block"
                     v-if="!/Tenancy Agreement Period\s+\d+/.test(item.name)">
                    {{ item.data }}
                </div>

                <div v-else style="width: 200px;display: inline-block;margin-bottom: 50px">
                    <el-date-picker disabled v-model="item.data"
                                    format="dd MMM yyyy HH:mm:ss"
                                    value-format="dd MMM yyyy HH:mm:ss"
                                    type="datetimerange"></el-date-picker>
                </div>
            </div>
        </div>
        <div style="width: 10%;display: inline-block;">
            <el-checkbox v-model="items[0].reject">Reject</el-checkbox>
        </div>
    </div>
</template>

<script>
export default {
    name: "AuditItem",
    props: {
        items: {}
    }

}
</script>

<style scoped>

</style>
